import React from "react"
import MaterialTable, { MTableToolbar } from "material-table"

export const ConcreteTableEn = () => {
  const data = [
    { naziv: "C 12/15	", oznaka: "T-15-3F	", aditiv: "NO", frakcije: "3" },
    { naziv: "C 16/20	", oznaka: "T-20-3F	", aditiv: "NO", frakcije: "3" },
    { naziv: "C 20/25	", oznaka: "T-25-3F	", aditiv: "NO", frakcije: "3" },
    { naziv: "C 25/30	", oznaka: "T-30-3F	", aditiv: "NO", frakcije: "3" },
    { naziv: "C 25/30	", oznaka: "T-30-4F	", aditiv: "NO", frakcije: "4" },
    { naziv: "C 25/30	", oznaka: "PILOT-30-4F	", aditiv: "NO", frakcije: "4" },
    { naziv: "C 25/30	", oznaka: "T-30-MS-3F	", aditiv: "YES", frakcije: "3" },
    { naziv: "C 30/37	", oznaka: "T-37-3F	", aditiv: "YES", frakcije: "3" },
    { naziv: "C 30/37	", oznaka: "T-37MS-3F	", aditiv: "YES", frakcije: "3" },
    { naziv: "C 30/37	", oznaka: "T-37-4F	", aditiv: "YES", frakcije: "4" },
    { naziv: "C 35/45	", oznaka: "T-45MS-3F	", aditiv: "YES", frakcije: "3" },
    { naziv: "C 40/50	", oznaka: "T-50MS-3F	", aditiv: "YES", frakcije: "3" },
    { naziv: "C 35/45	", oznaka: "RIGOL	", aditiv: "YES", frakcije: "4" },
    { naziv: "GLAZE	", oznaka: "", aditiv: "NO", frakcije: "2" },
    {
      naziv: "CEMENT STABILISATION 0-30 ROCK (T)",
      aditiv: "NO",
      frakcije: "0-30 CRUSHED STONE",
    },
    {
      naziv: "CEMENT STABILISATION 0-30 ROCK (T)",
      aditiv: "NO",
      frakcije: "GRAVEL",
    },
  ]
  const columns = [
    {
      title: "Compressive Strength Class:",
      field: "naziv",
      cellStyle: {
        backgroundColor: "hsl(209, 34%, 30%)",
        color: "#FFF",
        textAlign: "center",
      },
      headerStyle: {
        backgroundColor: "rgb(50, 77, 103)",
        paddingLeft: "2.6rem",
        color: "white",
        textAlign: "center",
        fontSize: "1.1rem",
        height: "5rem",
      },
    },
    {
      title: "Composition Mark",
      field: "oznaka",
      cellStyle: {
        backgroundColor: "hsl(209, 34%, 30%)",
        color: "#FFF",
        textAlign: "center",
      },
      headerStyle: {
        backgroundColor: "rgb(50, 77, 103)",
        paddingLeft: "2.6rem",
        color: "white",
        textAlign: "center",
        fontSize: "1.1rem",
        height: "5rem",
      },
    },
    {
      title: "Additive",
      field: "aditiv",
      cellStyle: {
        backgroundColor: "hsl(209, 34%, 30%)",
        color: "#FFF",
        textAlign: "center",
      },
      headerStyle: {
        backgroundColor: "rgb(50, 77, 103)",
        paddingLeft: "2.6rem",
        color: "white",
        textAlign: "center",
        fontSize: "1.1rem",
        height: "5rem",
      },
    },
    {
      title: "Fraction",
      field: "frakcije",
      cellStyle: {
        backgroundColor: "hsl(209, 34%, 30%)",
        color: "#FFF",
        textAlign: "center",
      },
      headerStyle: {
        backgroundColor: "rgb(50, 77, 103)",
        paddingLeft: "2.6rem",
        color: "white",
        textAlign: "center",
        fontSize: "1.1rem",
        height: "5rem",
      },
    },
  ]
  return (
    <div>
      <MaterialTable
        title="Betonska masa"
        components={{
          Toolbar: props => (
            <div
              style={{
                position: "absolute",
                textAlign: "right",
              }}
            >
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        options={{
          search: false,

          paging: false,
        }}
        data={data}
        columns={columns}
      />
    </div>
  )
}
